import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { inputOnlyNumber, millionComma, removeMillionComma } from "../utils";

const defaultModes = [
  { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
  { mode: "USD", conv: 1, conv_amt: "", amt: "" },
  { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
  { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
];

const normalizePayDtl = (payList) => {
  if (!Array.isArray(payList) || payList.length === 0) {
    return defaultModes;
  }
  return defaultModes.map((def) => {
    const found = payList.find((p) => p.mode === def.mode);
    if (found) {
      return {
        ...def,
        ...found,
        conv: found.conv ?? def.conv,
        conv_amt:
          found.conv_amt !== undefined && found.conv_amt !== ""
            ? found.conv_amt
            : found.amt !== undefined && found.amt !== ""
            ? found.amt
            : "",
        amt: found.amt !== undefined && found.amt !== "" ? found.amt : "",
      };
    }
    return def;
  });
};

const PayDtlCard = ({
  cardMode,
  showPayDtl,
  handlePayDtl,
  formInputs,
  setFormInputs,
  grossTotal,
}) => {
  const totalRef = useRef(0);
  const [paymentDetails, setPaymentDetails] = useState(
    normalizePayDtl(formInputs?.pay_dtl)
  );
  const [amountError, setAmountError] = useState(false);
  const [balanceAmount, setBalanceAmount] = useState(0);

  useEffect(() => {
    setPaymentDetails(normalizePayDtl(formInputs?.pay_dtl));
  }, [formInputs?.pay_dtl]);

  console.log("formInputs?.pay_dtlformInputs?.pay_dtl", formInputs?.pay_dtl);

  useEffect(() => {
    // if (cardMode !== "view") {
    //   let remainingAmount = parseFloat(grossTotal) || 0;
    //   paymentDetails.forEach((pay) => {
    //     if (pay.mode !== "Cash UGX") {
    //       remainingAmount -= parseFloat(pay.amt || 0);
    //     }
    //   });
    //   console.log("remainingAmount", remainingAmount);
    //   const updatedPayments = paymentDetails.map((pay) => {
    //     if (pay.mode === "Cash UGX") {
    //       let amount =
    //         parseFloat(remainingAmount) < 0
    //           ? parseFloat(grossTotal)
    //           : parseFloat(remainingAmount);

    //       return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
    //     } else {
    //       return parseFloat(remainingAmount) < 0
    //         ? { ...pay, amt: "", conv_amt: "" }
    //         : pay;
    //     }
    //   });

    //   console.log("updatedPaymentsupdatedPayments", updatedPayments);
    //   setPaymentDetails(updatedPayments);
    //   setFormInputs((prevState) => ({
    //     ...prevState,
    //     pay_dtl: updatedPayments,
    //   }));
    // }
    if (cardMode !== "view") {
      let remainingAmount = parseFloat(grossTotal) || 0;

      paymentDetails.forEach((pay) => {
        if (pay.mode !== "Cash UGX") {
          remainingAmount -= parseFloat(pay.amt || 0);
        }
      });


      const updatedPayments = paymentDetails.map((pay) => {
        if (pay.mode === "Cash UGX") {
          let amount = parseFloat(remainingAmount);

          return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
        } else {
          return pay;
        }
      });

      console.log("updatedPayments", updatedPayments);

      setPaymentDetails(updatedPayments);
      setFormInputs((prevState) => ({
        ...prevState,
        pay_dtl: updatedPayments,
      }));
    }
  }, [grossTotal]);

  const handlePaymentInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedPayments = [...paymentDetails];
    updatedPayments[index] = {
      ...updatedPayments[index],
      [name]: value,
    };
    setPaymentDetails(updatedPayments);
    setFormInputs((prevState) => ({
      ...prevState,
      pay_dtl: updatedPayments,
    }));
  };

  const calculateConvAmt = (e, index) => {
    let val = e.target.value;
    const updatedPayments = [...paymentDetails];
    let amt = removeMillionComma(val) * updatedPayments[index].conv_amt;
    updatedPayments[index] = {
      ...updatedPayments[index],
      amt: isNaN(amt) ? 0 : amt,
    };
    setPaymentDetails(updatedPayments);
    setFormInputs((prevState) => ({
      ...prevState,
      pay_dtl: updatedPayments,
    }));
  };

  const handleAmountChange = (e, index) => {
    const { value } = e.target;
    const updatedPayments = [...paymentDetails];
    let convRate = updatedPayments[index].conv;

    let amt = value && convRate ? removeMillionComma(value) * convRate : value;

    updatedPayments[index] = {
      ...updatedPayments[index],
      amt: isNaN(amt) ? 0 : amt,
      conv_amt: value,
    };

    setPaymentDetails(updatedPayments);
    setFormInputs((prevState) => ({
      ...prevState,
      pay_dtl: updatedPayments,
    }));
  };

  function calculateTotalPay() {
    totalRef.current.value = 0;
    paymentDetails.forEach((item) => {
      totalRef.current.value = removeMillionComma(totalRef.current.value);
      let total = isNaN(parseFloat(totalRef.current.value))
        ? 0
        : parseFloat(totalRef.current.value);
      let total_amt = isNaN(parseFloat(item.amt)) ? 0 : parseFloat(item.amt);

      let amt = parseFloat(total + total_amt).toFixed(2);
      totalRef.current.value = millionComma(amt);
    });
  }

  useEffect(
    function () {
      calculateTotalPay();
    },
    [paymentDetails]
  );

  useEffect(() => {
    calculateTotalPay();
    const totalPayment = removeMillionComma(totalRef?.current?.value);
    let balance = parseFloat(grossTotal) - parseFloat(totalPayment);
    setBalanceAmount(balance);
    if (
      parseFloat(totalPayment).toFixed(2) != parseFloat(grossTotal).toFixed(2)
    ) {
      setAmountError(true);
    } else {
      setAmountError(false);
    }
  }, [paymentDetails]);

  return (
    <Modal show={showPayDtl} onHide={handlePayDtl} size="lg">
      <Modal.Header>
        <Modal.Title>Payment Breakup</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th width="25%">Pay Mode</th>
                <th>
                  {/* Conversion (Rate &nbsp; x &nbsp; Amount)   */}
                  Conversion Rate x Amount
                </th>
                <th width="30%">Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {paymentDetails.map((pay, index) => (
                <tr key={index}>
                  <td>{pay.mode}</td>
                  {/* <td>{pay.mode === "Momo Pay" ? "MTN Pay" : pay.mode}</td> */}
                  <td>
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        className={`form-control  text-end ${
                          pay.mode !== "USD" ? "invisible" : ""
                        }`}
                        name="conv"
                        value={pay.conv}
                        onChange={(e) => {
                          handlePaymentInputChange(e, index);
                        }}
                        onBlur={(e) => {
                          calculateConvAmt(e, index);
                        }}
                        onKeyDown={inputOnlyNumber}
                        disabled={cardMode === "view"}
                        required
                        autocomplete="off"
                      />
                      <span
                        className={`align-items-center ${
                          pay.mode !== "USD" ? "invisible" : ""
                        }`}
                        style={{ width: "15%", textAlign: "center" }}
                      >
                        x
                      </span>
                      <input
                        type="text"
                        className="form-control text-end"
                        name="conv_amt"
                        value={pay.conv_amt}
                        onChange={(e) => {
                          handleAmountChange(e, index);
                        }}
                        onKeyDown={inputOnlyNumber}
                        disabled={cardMode === "view"}
                        required
                        autocomplete="off"
                      />
                    </div>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control text-end"
                      name="amt"
                      value={millionComma(pay.amt)}
                      disabled
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="row">
          <div className="col-md-6">
            <label htmlFor="totalRef"> Gross Total</label>
            <input
              type="text"
              className="form-control text-end"
              id="totalRef"
              value={millionComma(grossTotal)}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="totalRef">Total</label>
            <input
              type="text"
              className="form-control text-end"
              id="totalRef"
              ref={totalRef}
              disabled
            />
            {amountError && (
              <div className="text-danger mt-1">
                Total amount should be same as Gross Total
              </div>
            )}
            <p className="mt-2 ">
              <span style={{ color: "blue" }}>Balance</span> : {" "}
              {millionComma(balanceAmount)}
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary rounded-2"
          onClick={handlePayDtl}
          disabled={cardMode !== "view" && amountError}
        >
          {cardMode !== "view" ? "Save & Close" : "Close"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PayDtlCard;
